import { graphql } from "gql";

const START_CALL_MUTATION = graphql(`
  mutation StartCall($invitedUserIdList: [ID!]!, $isVideo: Boolean!) {
    startCall(
      input: { invitedUserIdList: $invitedUserIdList, isVideo: $isVideo }
    ) {
      ...Call
    }
  }
`);

export default START_CALL_MUTATION;
